export const E_COMMERCE_STYLES = {
  container: {
    maxWidth: 520,
    maxWidthTablet: 768,
    maxWidthTabletLg: 800,
    maxWidthWeb: 1200,
    maxWdithLarge: 1440,
    maxWidthExtraLarge: 1600,
    mx: 'auto',
  },
};
